module.exports = __webpack_public_path__ + "assets/img/3c1d12ec5493d5020f64f561f3c86ab0.svg";